const compatModules = {};import * as Mod1 from "./discourse/initializers/github-admin-plugin-configuration-nav";
compatModules["discourse/initializers/github-admin-plugin-configuration-nav"] = Mod1;

export * as discourse$initializers$github__admin__plugin__configuration__nav$$__module from "./discourse/initializers/github-admin-plugin-configuration-nav";
export {
default as discourse$initializers$github__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/github-admin-plugin-configuration-nav";
export default compatModules;
